import { lang } from "../core/variables-global.js";

let datePicker = () => {
  if (typeof flatpickr === "undefined") {
    return;
  }

  const dateInputs = document.querySelectorAll(".js-date-picker:not(.flatpickr-input)");
  const today = new Date();
  const minDate = new Date();
  minDate.setMonth(today.getMonth() - 9);

  if (!dateInputs.length) return;

  // Détecter si l'appareil est mobile
  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
      window.innerWidth <= 640;
  }

  // Faire défiler vers l'élément .js-stop-step-1
  function scrollToStep1() {
    const targetElement = document.querySelector(".js-stop-step-1");
    if (targetElement) {
      const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth"
      });
    }
  }

  // Surveiller la fin du scroll et déclencher une callback
  function onScrollEnd(callback) {
    let isScrolling;
    const scrollListener = function () {
      clearTimeout(isScrolling);
      isScrolling = setTimeout(function () {
        window.removeEventListener("scroll", scrollListener);
        callback();
      }, 66);
    };
    window.addEventListener("scroll", scrollListener);
  }

  dateInputs.forEach(input => {
    if (!input._flatpickr) {
      let userInitiatedAction = false;
      let dateSelected = false;

      const flatpickrInstance = flatpickr(input, {
        dateFormat:"Y-m-d",
        locale: lang,
        disableMobile: true,
        position: "below",
        altInput: false,
       maxDate: today,
        minDate: minDate,
        altFormat: "j F Y",
        onOpen: function () {
          if (isMobileDevice()) {
            scrollToStep1();
          }
          // Empêcher le scroll avec la barre espace dans le date picker
          setTimeout(() => {
            const flatpickrCalendar = document.querySelector(".flatpickr-calendar.open");
            if (flatpickrCalendar) {
              flatpickrCalendar.addEventListener("keydown", function(e) {
                if (e.key === " " || e.keyCode === 32) {
                  e.preventDefault();
                }
              });
            }
          }, 0);
        },
        onChange: function (selectedDates, dateStr) {
          input.value = dateStr;
          dateSelected = true;

          // Empêcher les futures actions automatiques après sélection
          userInitiatedAction = false;

          const event = new CustomEvent("flatpickr-change", {
            detail: {
              dateStr: dateStr,
              date: selectedDates[0]
            },
            bubbles: true
          });
          document.dispatchEvent(event);
        }
      });

      if (isMobileDevice()) {
        input.addEventListener("touchstart", function (e) {
          if (dateSelected) return;
          userInitiatedAction = true;
          scrollToStep1();
          onScrollEnd(() => {
            // Vérifier à nouveau si une date n'a pas été sélectionnée entre temps
            if (!dateSelected && userInitiatedAction) {
              flatpickrInstance.open();
            }
            userInitiatedAction = false;
          });
        }, { passive: true });

        input.addEventListener("focus", function (e) {
          if (dateSelected) return;
          if (!userInitiatedAction) return;

          scrollToStep1();
          onScrollEnd(() => {
            // Vérifier à nouveau si une date n'a pas été sélectionnée entre temps
            if (!dateSelected && userInitiatedAction) {
              flatpickrInstance.open();
            }
            userInitiatedAction = false;
          });
        });
      }

      input.addEventListener("keydown", function(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
          e.preventDefault();
        }
        if (e.key === " " || e.keyCode === 32) {
          e.preventDefault();
        }
      });
    }
  });
};

window.datePicker = datePicker();
export default window.datePicker;

